import { Utils } from '../../underscore-extensions';

const WAVE = 0;

class SubscriptionAppSumoPlan implements ng.IComponentController {
    planName: string;
    formattedPlanName: string;
    code: string;

    constructor() {
        this.formattedPlanName = Utils.getDisplayPlanName(this.planName);
    }

    isHighestPlan() {
        return options.user.subscriptionDetails.wave.name === 'WaveBusinessAppSumo';
    }
}

angular.module('animatronApp.SubscriptionAppSumoPlan', []).component('subscriptionAppSumoPlan', {
    bindings: { planName: '<' },
    controller: SubscriptionAppSumoPlan,
    templateUrl: require('settings/subscription/subscription-app-sumo-plan.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionAppSumoPlan.ts